import { Link, useNavigate, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from 'axios';
import config from "../../Common/Configurations/APIConfig";
import Header from "../../Common/Layout/Header";
import SideBar from "../../Common/Layout/Sidebar";
import QuantitySpinner from "../Master/QuantitySpinner";
import { handleError, handleSuccess } from "../../Common/Layout/CustomAlerts";
export default function PurchaseFunder() {
    const [lists, setLists] = useState([]);
    const [quantities, setQuantities] = useState({});
    const headerconfig = {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("userToken"),
            "Content-Type": "application/json"
        }
    }
    const GetData = () => {
        axios
            .get(config.APIACTIVATEURL + config.GETPRICING + "?pageNumber=1&pageSize=100", { ...headerconfig })
            .then((response) => {
                if (response.status === 200) {
                    setLists(response.data.data.data);
                }
            });
    };
    const updateQuantity = (pricingId, newQuantity) => {
        setQuantities(prev => ({
            ...prev,
            [pricingId]: newQuantity
        }));
    };
    const handlePurchase = (item, quantity) => {
        // Example usage
        console.log("Purchasing:", {
            pricingId: item.pricingId,
            usage: item.usage,
            monthlyFee: item.monthlyFee,
            quantity,
            total: parseInt(item.monthlyFee) * quantity,
        });
        axios.post(config.APIACTIVATEURL + config.UPDATEADDONS + "?ClientId=" + localStorage.getItem('clientId')+"&usageType="+item.usage+"&quantity="+quantity, { ...headerconfig })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    handleSuccess(response.data.message);
                }
                else {
                    handleError("Error in updating AddOns")
                }
            });
    };

    useEffect(() => {
        GetData();
    }, [])

    return (
        <div id="layout-wrapper">
            <Header></Header>
            <SideBar></SideBar>
            <div className="body-wrapper">
                <div className="container-fluid">
                    <div className="card">
                        <div className="card-header border-0">
                            <div className="row g-4">
                                <div className="col-sm-10">
                                    <h4 className="mb-sm-0">Rate Card</h4>
                                </div>
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="table-responsive table-card">
                                <table className="table align-middle">
                                    <thead>
                                        <tr>
                                            <th>Id</th>
                                            <th>Usage</th>
                                            <th>Monthly Fee</th>
                                            <th>Quantity</th>
                                            <th>Total Price</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody className="list form-check-all">
                                        {lists.length > 0 && lists.map((v, index) =>
                                            <tr key={v.pricingId}>
                                                <td>{index + 1}</td>
                                                <td>{v.usage}</td>
                                                <td>{v.monthlyFee} USD</td>
                                                <td>
                                                    <QuantitySpinner quantity={quantities[v.pricingId] || 1} setQuantity={(q) => updateQuantity(v.pricingId, q)}></QuantitySpinner>
                                                </td>
                                                <td>{parseInt(v.monthlyFee) * (quantities[v.pricingId] || 1)} USD per month</td>
                                                <td>
                                                    <ul className="list-inline hstack gap-2 mb-0">
                                                        <li className="list-inline-item" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" title="Edit">
                                                            <button className="btn btn-sm btn-success" onClick={() => handlePurchase(v, quantities[v.pricingId] || 1)}>Purchase</button>
                                                        </li>
                                                    </ul>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}